'use client';

import React, { useContext, useEffect, useState } from 'react';

type ContextType = { tcData?: any; ads?: any };

const AdsContext = React.createContext<ContextType>({ tcData: {}, ads: undefined });

export const AdsProvider: React.FC<React.PropsWithChildren & ContextType> = ({ children, tcData = false, ads }) => {
  const [state, setState] = useState({ ads });
  useEffect(() => {
    const setValues = () => {
      if (!window.__tcfapi) {
        return false;
      }
      window.__tcfapi?.('addEventListener', 2, (winTcData) => {
        setState((x) => {
          return { ...x, tcData: winTcData };
        });
      });
      return true;
    };

    if (!tcData && !setValues()) {
      const interval = setInterval(() => {
        if (setValues()) {
          clearInterval(interval);
        }
      }, 200);
      return () => {
        clearInterval(interval);
      };
    }
    return undefined;
  }, [tcData]);

  return <AdsContext.Provider value={state}>{children}</AdsContext.Provider>;
};

export const useAds = () => {
  return useContext(AdsContext);
};
